import React, { useState, useEffect } from "react"
import { connect } from "react-redux"
import { Form, Input, Button, Card, Row, Col, Tag, Modal, Popconfirm } from "antd"
import { MainActions } from "redux-store/models"

function FintechConnection(props) {
  const {
    form,
    connectFintech,
    fintechUrl,
    fintechAccounts,
    getFintechAccounts,
    updateFintechAccount,
  } = props

  const { getFieldDecorator } = form

  const [loading, setLoading] = useState(false)
  const [modalVisible, setModalVisible] = useState(false)

  const requiredLabel = (text) => (
    <>
      {text} <span style={{ color: "#ff4d4f" }}>*</span>
    </>
  )

  const requiredRule = (message) => ({
    required: true,
    message,
  })

  const handleSubmit = (e) => {
    e.preventDefault()

    form.validateFields((err, values) => {
      if (err) return

      connectFintech(
        values.iban,
        values.asp_code,
        values.codice_fiscale,
        values.name,
        values.surname,
        values.partita_iva,
        values.denominazione,
        values.tipoSocietario,
        setLoading,
      )

      // setModalVisible(false)
    })
  }

  useEffect(() => {
    if (fintechUrl) {
      window.open(fintechUrl, "_blank")
      form.resetFields()
    }
  }, [fintechUrl])

  useEffect(() => {
    getFintechAccounts(1, 20)
  }, [])

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        padding: 24,
        width: "100%",
        height: "100vh",
        overflowY: "auto",
        boxSizing: "border-box",
      }}
    >
      <div style={{ marginBottom: 16 }}>
        <Button type="primary" onClick={() => setModalVisible(true)}>
          Connect Fintech
        </Button>
      </div>

      <Row gutter={16}>
        {fintechAccounts.map((acc) => (
          <Col xs={24} sm={12} md={8} key={acc.id}>
            <Card
              hoverable
              style={{
                borderRadius: 10,
                boxShadow: "0 2px 10px rgba(0,0,0,0.06)",
                borderLeft: acc.is_active
                  ? "4px solid #52c41a"
                  : "4px solid #f5222d",
              }}
            >
              <div
                style={{
                  marginBottom: 12,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: 8,
                }}
              >
                <div style={{ fontWeight: 600, fontSize: 13 }}>{acc.bank_name}</div>

                <Popconfirm
                  title={`Stai per ${
                    acc.is_active ? "disattivare" : "attivare"
                  } il conto ${acc.bank_name}`}
                  okText="Approva"
                  cancelText="Annulla"
                  onConfirm={() => updateFintechAccount(acc.id)}
                >
                  <Tag
                    color={acc.is_active ? "green" : "red"}
                    style={{
                      cursor: "pointer",
                      userSelect: "none",
                      lineHeight: "20px",
                      height: 22,
                      padding: "0 8px",
                      display: "inline-flex",
                      alignItems: "center",
                    }}
                  >
                    {acc.is_active ? "Active" : "Inactive"}
                  </Tag>
                </Popconfirm>
              </div>

              <div style={{ marginBottom: 8 }}>
                <div style={{ fontSize: 11, color: "#888" }}>IBAN</div>
                <div style={{ fontWeight: 500, wordBreak: "break-all" }}>
                  {acc.iban}
                </div>
              </div>

              <div style={{ marginBottom: 8 }}>
                <div style={{ fontSize: 11, color: "#888" }}>Holder CF/P.IVA</div>
                <div>{acc.holder_cf_piva}</div>
              </div>

              <div style={{ marginBottom: 10 }}>
                <div style={{ fontSize: 11, color: "#888" }}>Created</div>
                <div>{new Date(acc.created_at).toLocaleString()}</div>
              </div>

              <div
                style={{
                  marginTop: 10,
                  paddingTop: 10,
                  borderTop: "1px solid #f0f0f0",
                }}
              >
                <div style={{ fontSize: 11, color: "#888", marginBottom: 6 }}>
                  User Info
                </div>

                <div style={{ fontSize: 12 }}>
                  <div>
                    <b>Name:</b> {acc.meta_data?.User?.Nome}{" "}
                    {acc.meta_data?.User?.Cognome}
                  </div>
                  <div>
                    <b>Email:</b> {acc.meta_data?.User?.Email}
                  </div>
                  <div>
                    <b>CF:</b> {acc.meta_data?.User?.CodiceFiscale}
                  </div>
                </div>
              </div>
            </Card>
          </Col>
        ))}
      </Row>

      <Modal
        title="Connect Fintech"
        visible={modalVisible}
        onCancel={() => setModalVisible(false)}
        footer={null}
        destroyOnClose
      >
        <Form layout="vertical" onSubmit={handleSubmit} className="fintech-form">
          <Form.Item label={requiredLabel("IBAN")}>
            {getFieldDecorator("iban", {
              rules: [requiredRule("Inserisci l'IBAN")],
            })(<Input />)}
          </Form.Item>

          <Form.Item label={requiredLabel("Codice Fiscale")}>
            {getFieldDecorator("codice_fiscale", {
              rules: [requiredRule("Inserisci il codice fiscale")],
            })(<Input />)}
          </Form.Item>

          <Form.Item label={requiredLabel("Nome")}>
            {getFieldDecorator("name", {
              rules: [requiredRule("Inserisci il nome")],
            })(<Input />)}
          </Form.Item>

          <Form.Item label={requiredLabel("Cognome")}>
            {getFieldDecorator("surname", {
              rules: [requiredRule("Inserisci il cognome")],
            })(<Input />)}
          </Form.Item>

          <Form.Item label={requiredLabel("Denominazione")}>
            {getFieldDecorator("denominazione", {
              rules: [requiredRule("Inserisci la denominazione")],
            })(<Input />)}
          </Form.Item>

          <Form.Item label={requiredLabel("Tipo Societario")}>
            {getFieldDecorator("tipoSocietario", {
              rules: [requiredRule("Inserisci il tipo societario")],
            })(<Input />)}
          </Form.Item>

          <Form.Item label="ASP Code">
            {getFieldDecorator("asp_code")(<Input />)}
          </Form.Item>

          <Form.Item label="Partita IVA">
            {getFieldDecorator("partita_iva")(<Input />)}
          </Form.Item>

          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              onClick={() => setModalVisible(false)}
              style={{ marginRight: 8 }}
            >
              Cancel
            </Button>

            <Button type="primary" htmlType="submit" loading={loading}>
              Connect
            </Button>
          </div>
        </Form>
      </Modal>
    </div>
  )
}

const mapStateToProps = (state) => ({
  fintechUrl: state.main.fintechUrl,
  fintechAccounts: state.main.fintechAccounts,
})

export default connect(
  mapStateToProps,
  MainActions,
)(Form.create()(FintechConnection))
